const initialState = {
  caseManager: {
    id: '',
    value: '',
  },
  referralType: {
    athTypId: ''
  },
  CbpCmID: '',
  startDate: '',
  endDate: '',
  newCbpCaseManager: false,
};

export default initialState;
